function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { useTheme } from '@veneer/theme';
import squared from 'polished/lib/shorthands/size';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
function normalizeQuietArea(value) {
  if (!value || value < 0) return undefined;
  if (value > 100) return 100;
  return value;
}
var useStyles = _ref => {
  var {
    color,
    disabled,
    flippable,
    isRTL,
    isSvg,
    quietArea,
    size
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var quietAreaSize = quietArea && typeof size === 'number' ? typeof quietArea === 'function' ? quietArea(size) : Math.ceil(quietArea * size / 100) : undefined;
    return _objectSpread(_objectSpread(_objectSpread({
      boxSizing: 'border-box',
      cursor: disabled ? 'default' : undefined,
      display: 'inline-block',
      filter: disabled ? 'grayscale(1)' : undefined,
      padding: normalizeQuietArea(quietAreaSize),
      userSelect: 'none',
      width: !isSvg ? size : undefined
    }, highContrastMediaQuery(theme)), isSvg && _objectSpread({
      color: color ? theme.color[color] || theme.palette.foreground.default : theme.palette.foreground.default,
      fill: 'currentColor'
    }, squared(size))), isRTL && flippable && {
      transform: 'scaleX(-1)'
    });
  }, [color, disabled, flippable, isRTL, isSvg, quietArea, size, theme]);
};
export default useStyles;